import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaLeaf } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#0F5132] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src="/shivangel-logo.png" alt="Shivangel Logo" className="h-10 w-10" />
              <div>
                <h3 className="text-lg font-bold">SHIVANGEL</h3>
                <p className="text-xs text-[#0F5132]">Ayurveda & Nutraceuticals</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed">
              ISO, GMP & AYUSH Certified manufacturing facility with 25,000+ sq ft production capacity.
            </p>
            <div className="mt-4 flex space-x-2">
              <div className="px-3 py-1 bg-white/10 rounded text-xs">ISO Certified</div>
              <div className="px-3 py-1 bg-white/10 rounded text-xs">GMP</div>
              <div className="px-3 py-1 bg-white/10 rounded text-xs">AYUSH</div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-[#0F5132] transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-[#0F5132] transition-colors">About Us</Link></li>
              <li><Link to="/products" className="hover:text-[#0F5132] transition-colors">Product Catalogue</Link></li>
              <li><Link to="/manufacturing" className="hover:text-[#0F5132] transition-colors">Manufacturing</Link></li>
              <li><Link to="/third-party-manufacturing" className="hover:text-[#0F5132] transition-colors">Third-Party Manufacturing</Link></li>
              <li><Link to="/quality" className="hover:text-[#0F5132] transition-colors">Quality Assurance</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-[#0F5132] transition-colors cursor-pointer">Private Label Manufacturing</li>
              <li className="hover:text-[#0F5132] transition-colors cursor-pointer">Custom Formulation</li>
              <li className="hover:text-[#0F5132] transition-colors cursor-pointer">Bulk Manufacturing</li>
              <li className="hover:text-[#0F5132] transition-colors cursor-pointer">Packaging Solutions</li>
              <li className="hover:text-[#0F5132] transition-colors cursor-pointer">Regulatory Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-[#0F5132] mt-1 flex-shrink-0" />
                <p className="text-gray-300">
                  Village Jaspur, Mauli-Ambala Road<br />
                  Panchkula, Haryana, India
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="text-[#0F5132] flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-400 mb-1">Directors</p>
                  <p>8950999600 (Shamsher Sharma)</p>
                  <p>8264999600 (Shivansh Vats)</p>
                  <p>7508009999 (Rekha Sharma)</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <FaEnvelope className="text-[#0F5132] flex-shrink-0" />
                <p className="break-all">shivangelayurveda.nutra@gmail.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Shivangel Technopack Pvt. Ltd. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <p className="text-sm text-gray-400">
                A Unit of Shivangel Technopack Pvt. Ltd.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;